export { EquipmentModule } from './equipment/equipment.module';
export { EquipmentComponentsModule } from './equipment-components/equipment-components.module';
export { EquipmentDetailsModule } from './equipment-details/equipment-details.module';
export { EquipmentReportCategoriesModule } from './equipment-report-categories/equipment-report-categories.module';

export { EquipmentReportCategoriesDialogModule } from './equipment-report-categories-dialog/equipment-report-categories-dialog.module';
export * from './equipment-report-categories-dialog/equipment-report-categories-dialog.component';
export * from './equipment-report-categories-dialog/equipment-report-categories-dialog.model';
